import * as React from 'react';
import { Check } from 'react-feather';

export function DefaultDomInputValidIconContent() {
  return <Check />;
}
